import React, { useState, useEffect, useMemo } from "react";
import styled from "styled-components";

import {
    Button,
    Icon,
    Table,
    Segment,
    Dimmer,
    Confirm,
    Popup,
    Loader,
    List,
    Pagination,
    Checkbox,
} from "semantic-ui-react";

import { useSelector, shallowEqual, useDispatch } from "react-redux";

import {
    SG_FETCH_FILE_UPLOAD,
    SG_EDIT_FILE_UPLOAD,

} from "constants/actions";

import format from "date-fns/format";

import Update from "./Update";
import BasicErrorMessage from "utilities/ErrorMessages";

// import { EmployeeImport } from "data/datastructure/Import"

function elementCount(arr, element) {
    return arr.reduce((currentElement, arrElement) =>
        (arrElement == element ? currentElement + 1 : currentElement), 0);
};

function ValidateCheckEmail({ k, item, head,
    fieldValues, validFieldName, validEmailList,
    uploadedEmailList }) {

    if (head === "email") {
        if (!item?.email) {
            return (
                <Table.Cell key={k} negative>
                    <Popup
                        content="This field cannot be empty"
                        trigger={<Icon name="attention" />}
                    />
                    {item[head]}
                </Table.Cell>
            );
        }
        const FoundMultiple = (elementCount(uploadedEmailList, item.email))
        if (FoundMultiple > 1) {
            return (
                <Table.Cell key={k} negative>
                    <Popup
                        content="Multiple emails found"
                        trigger={<Icon name="attention" />}
                    />
                    {item[head]}
                </Table.Cell>
            );
        }
        const Found = validEmailList.includes(item?.email)
        if (Found) {
            return (
                <Table.Cell key={k} negative>
                    <Popup
                        content="This email id has been used"
                        trigger={<Icon name="attention" />}
                    />
                    {item[head]}
                </Table.Cell>
            );
        } else {
            return (
                <Table.Cell key={k} positive>
                    <Popup
                        content="This email can be used"
                        trigger={<Icon color="green" name="checkmark" />}
                    />
                    {item[head]}{" "}
                </Table.Cell>
            );

        }
    }
    if (head === "first_name" || head === "last_name") {

        return (
            <Table.Cell key={k} positive>
                <Popup
                    content="This is a valid choice"
                    trigger={<Icon color="green" name="checkmark" />}
                />
                {item[head]}{" "}
            </Table.Cell>
        );
    }
    if (validFieldName[head]) {
        if (validFieldName[head]?.priority === 'primary') {
            if (fieldValues?.[head]) {
                const Found1 = fieldValues[head].find(({ name }) => name === item[head])
                // console.log(Found1)
                if (!item[head]) {
                    return <Table.Cell key={k}>{item[head]} </Table.Cell>;
                }

                if (Found1) {
                    return (
                        <Table.Cell key={k} positive>
                            <Popup
                                content="This is a valid choice"
                                trigger={<Icon color="green" name="checkmark" />}
                            />
                            {item[head]}{" "}
                        </Table.Cell>
                    );
                } else {
                    return (
                        <Table.Cell key={k} negative>
                            <Popup
                                content="This is not a valid choice"
                                trigger={<Icon name="attention" />}
                            />
                            {item[head]}
                        </Table.Cell>
                    );
                }
            }
        } else {

            const Found1 = validFieldName[head]?.options.find(({ name }) => name === item[head])
            // console.log(Found1)
            if (!item[head]) {
                return <Table.Cell key={k}>{item[head]} </Table.Cell>;
            }

            if (Found1) {
                return (
                    <Table.Cell key={k} positive>
                        <Popup
                            content="This is a valid choice"
                            trigger={<Icon color="green" name="checkmark" />}
                        />
                        {item[head]}{" "}
                    </Table.Cell>
                );
            } else {
                return (
                    <Table.Cell key={k} negative>
                        <Popup
                            content="This is not a valid choice"
                            trigger={<Icon name="attention" />}
                        />
                        {item[head]}
                    </Table.Cell>
                );
            }
        }
    }


    return <Table.Cell key={k}>{item[head]} </Table.Cell>;
}

function ValidateCheckEmailModern({ k, item, head,
    fieldValues, validFieldName, validEmailList,
    uploadedEmailList }) {

    if (head === "email") {
        if (!item?.email) {
            return (
                <DataCell key={k} error={true}>
                    <CellContent>
                        <Popup
                            content="This field cannot be empty"
                            trigger={
                                <ValidationIcon status="error">
                                    <Icon name="attention" />
                                </ValidationIcon>
                            }
                        />
                        <CellText>{item[head]}</CellText>
                    </CellContent>
                </DataCell>
            );
        }
        const FoundMultiple = (elementCount(uploadedEmailList, item.email))
        if (FoundMultiple > 1) {
            return (
                <DataCell key={k} error={true}>
                    <CellContent>
                        <Popup
                            content="Multiple emails found"
                            trigger={
                                <ValidationIcon status="error">
                                    <Icon name="attention" />
                                </ValidationIcon>
                            }
                        />
                        <CellText>{item[head]}</CellText>
                    </CellContent>
                </DataCell>
            );
        }
        const Found = validEmailList.includes(item?.email)
        if (Found) {
            return (
                <DataCell key={k} error={true}>
                    <CellContent>
                        <Popup
                            content="This email id has been used"
                            trigger={
                                <ValidationIcon status="error">
                                    <Icon name="attention" />
                                </ValidationIcon>
                            }
                        />
                        <CellText>{item[head]}</CellText>
                    </CellContent>
                </DataCell>
            );
        } else {
            return (
                <DataCell key={k} valid={true}>
                    <CellContent>
                        <Popup
                            content="This email can be used"
                            trigger={
                                <ValidationIcon status="success">
                                    <Icon name="checkmark" />
                                </ValidationIcon>
                            }
                        />
                        <CellText>{item[head]}</CellText>
                    </CellContent>
                </DataCell>
            );

        }
    }
    if (head === "first_name" || head === "last_name") {

        return (
            <DataCell key={k} valid={true}>
                <CellContent>
                    <Popup
                        content="This is a valid choice"
                        trigger={
                            <ValidationIcon status="success">
                                <Icon name="checkmark" />
                            </ValidationIcon>
                        }
                    />
                    <CellText>{item[head]}</CellText>
                </CellContent>
            </DataCell>
        );
    }
    if (validFieldName[head]) {
        if (validFieldName[head]?.priority === 'primary') {
            if (fieldValues?.[head]) {
                const Found1 = fieldValues[head].find(({ name }) => name === item[head])
                if (!item[head]) {
                    return <DataCell key={k}><CellText>{item[head]}</CellText></DataCell>;
                }

                if (Found1) {
                    return (
                        <DataCell key={k} valid={true}>
                            <CellContent>
                                <Popup
                                    content="This is a valid choice"
                                    trigger={
                                        <ValidationIcon status="success">
                                            <Icon name="checkmark" />
                                        </ValidationIcon>
                                    }
                                />
                                <CellText>{item[head]}</CellText>
                            </CellContent>
                        </DataCell>
                    );
                } else {
                    return (
                        <DataCell key={k} error={true}>
                            <CellContent>
                                <Popup
                                    content="This is not a valid choice"
                                    trigger={
                                        <ValidationIcon status="error">
                                            <Icon name="attention" />
                                        </ValidationIcon>
                                    }
                                />
                                <CellText>{item[head]}</CellText>
                            </CellContent>
                        </DataCell>
                    );
                }
            }
        } else {

            const Found1 = validFieldName[head]?.options.find(({ name }) => name === item[head])
            if (!item[head]) {
                return <DataCell key={k}><CellText>{item[head]}</CellText></DataCell>;
            }

            if (Found1) {
                return (
                    <DataCell key={k} valid={true}>
                        <CellContent>
                            <Popup
                                content="This is a valid choice"
                                trigger={
                                    <ValidationIcon status="success">
                                        <Icon name="checkmark" />
                                    </ValidationIcon>
                                }
                            />
                            <CellText>{item[head]}</CellText>
                        </CellContent>
                    </DataCell>
                );
            } else {
                return (
                    <DataCell key={k} error={true}>
                        <CellContent>
                            <Popup
                                content="This is not a valid choice"
                                trigger={
                                    <ValidationIcon status="error">
                                        <Icon name="attention" />
                                    </ValidationIcon>
                                }
                            />
                            <CellText>{item[head]}</CellText>
                        </CellContent>
                    </DataCell>
                );
            }
        }
    }


    return <DataCell key={k}><CellText>{item[head]}</CellText></DataCell>;
}

const DebriefScheduleDetail = ({ showReportId, get_survey_structure }) => {
    const dispatch = useDispatch();

    const [fileUpload, setfileUpload] = useState([]);
    const [fileHeaders, setFileHeaders] = useState([]);
    const [validFields, setValidFields] = useState([])
    const [validatedValues, setValidatedValues] = useState([])
    const [controlledBy, setControlledBy] = useState({})
    const [fieldValues, setFieldValues] = useState({})
    const [parentField, setParentField] = useState({})
    const [jsonData, setJsonData] = useState([])
    const [fileUploadStatus, setFileUploadStatus] = useState(0)
    const [validFieldName, setValidFieldName] = useState([])

    const [uploadedEmailList, setUploadedEmailList] = useState([])
    const [showUploadLog, setShowUploadLog] = useState(false)
    const [uploadedLog, setUploadedLog] = useState([])

    const [rowInfo, setRowInfo] = useState([]);

    const [rowId, setRowId] = useState(false);
    const [openPortal, setopenPortal] = useState(false);

    const [validEmailList, setValidEmailList] = useState([])
    const [deleteId, setDeleteId] = useState(false);
    const [invalidRows, setInvalidRows] = useState(0);

    const [confirmDelete, setConfirmDelete] = useState(false);
    const [loadingPage, setLoadingPage] = useState(false)

    // Pagination state
    const [activePage, setActivePage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const itemsPerPage = 100;
    const [pagedData, setPagedData] = useState([]);

    // Show only invalid rows toggle
    const [showOnlyInvalid, setShowOnlyInvalid] = useState(false);
    const [showOnlyCategoryIssues, setShowOnlyCategoryIssues] = useState(false);
    const [showMissingCategoriesModal, setShowMissingCategoriesModal] = useState(false);

    const {
        get_file_uploads,
        get_email_list
        // get_selectedOrg
    } = useSelector(
        (state) => ({
            get_file_uploads: state.fileupload,
            get_email_list: state.employees.allEmailList,

            // get_selectedOrg: state.selectedOrg
        }),
        shallowEqual
    );

    useEffect(() => {
        if (showReportId) {
            dispatch({
                type: SG_FETCH_FILE_UPLOAD,
                payload: { id: showReportId },
            });
        }
    }, [dispatch, showReportId, rowId, openPortal]);

    useEffect(() => {
        setValidEmailList(get_email_list?.response)
    }, [get_email_list]);

    useEffect(() => {
        setfileUpload(get_file_uploads?.[showReportId]);
    }, [showReportId, get_file_uploads]);

    useEffect(() => {
        setFileUploadStatus(fileUpload?.status)
    }, [fileUpload]);

    console.log(fileUpload?.status)

    useEffect(() => {
        const _UserList = [];

        let _total = 0
        if (fileUpload?.review_data?.[0]) {
            if (fileUpload?.status > 2) {
                const _fileKeys = Object.keys(fileUpload?.review_data?.[0])
                const _index = _fileKeys.indexOf('category');
                delete _fileKeys[_index]
                const _index2 = _fileKeys.indexOf('employee_id');
                delete _fileKeys[_index2]
                console.log(_fileKeys)
                setFileHeaders(_fileKeys)
                // upload Log get email, id and category information in one row
                const _log = fileUpload?.review_data.filter(up => {
                    return ({
                        emai: up?.email,
                        employee_id: up?.employee_id,
                        status: up?.status,
                        category: up?.category
                    })
                })
                setUploadedLog(_log)

            } else {
                setFileHeaders(Object.keys(fileUpload?.review_data?.[0]))
            }

            fileUpload?.review_data.map((fl, i) => {
                const Found = validEmailList.includes(fl?.email);
                if (Found) {
                    // console.log("Invalid")
                    _total += 1;
                }
                let Found2 = 0
                // let EmptyRow = 0

                validFields.filter(vf => vf !== 'first_name')
                    .filter(vf => vf !== 'email').filter(vf => vf !== 'last_name').map(fld => {
                        // console.log(fld, ":", fl[fld])
                        if (fl[fld] === '') {
                            // console.log("null return")
                            return null
                        }
                        // if (!fl[fld]) {
                        //     EmptyRow = 1;
                        //     return null
                        // }

                        // Found2 = validFieldName[fld]?.options.find(({ name }) => name === fl[fld])
                        // validFieldName[fld]?.options.filter()
                        // if (fieldValues?.[fld]?.length > 0) {
                        //     // console.log(fieldValues[fld])
                        //     Found2 = fieldValues?.[fld].find(({ name }) => name === fl[fld])
                        // }
                        return null
                    })

                // if (!Found2) {
                //     // console.log("Found2", _total)
                //     _total += 1;
                // }
                // if (EmptyRow) {
                //     // console.log("EmptyRow", _total)
                //     _total += 1;
                // }

                return _UserList.push({
                    ...fl,
                    valid: Found,
                });
            });
            if (fileUpload?.status > 2) {
                _total = 0;
            }
            if (fileUpload?.status > 3) {
                _total += 100;
            }
        }

        setUploadedEmailList(_UserList.map(ur => ur.email))
        setJsonData(_UserList)
        setInvalidRows(_total)


    }, [fileUpload, validEmailList, validFieldName, validFields, parentField, validatedValues]);

    // console.log(invalidRows)

    useEffect(() => {
        // const _primaryList = [];
        // const _secondaryList = [];
        if (get_survey_structure?.length > 0) {
            setValidFields(get_survey_structure?.[0]?.field_map?.fields)
            setControlledBy(get_survey_structure?.[0]?.field_map?.controlled_by)
            setFieldValues(get_survey_structure?.[0]?.field_map?.values)
            setValidatedValues(get_survey_structure?.[0]?.field_map?.validated_values)
            setParentField(get_survey_structure?.[0]?.field_map?.parent_field)
            setValidFieldName(get_survey_structure?.[0]?.field_map?.valid_field_name)
        }
    }, [get_survey_structure]);

    // useEffect(() => {
    //     if (loadingPage && !get_file_uploads?.pending) {
    //         const timer1 = setTimeout(() => {
    //             setLoadingPage(false);
    //         }, 1000);
    //         return () => clearTimeout(timer1);
    //     }

    // }, [loadingPage, get_file_uploads]);

    useEffect(() => {
        setLoadingPage(get_file_uploads?.pending);
    }, [get_file_uploads]);

    // Predicate for row issues: item.valid currently flags an issue when true
    function rowHasIssue(item) {
        return fileUploadStatus < 3 && item?.valid === true;
    }

    // Predicate for category mismatch issues: at least one category value doesn't match allowed options
    function rowHasCategoryIssue(item) {
        if (fileUploadStatus > 2 || !item) return false;
        const categoryHeads = (validFields || []).filter((vf) => vf !== 'first_name' && vf !== 'last_name' && vf !== 'email');
        for (let i = 0; i < categoryHeads.length; i += 1) {
            const head = categoryHeads[i];
            const value = item[head];
            if (!value) continue;
            // Primary fields validate against fieldValues; others validate against validFieldName[head].options
            if (validFieldName[head]?.priority === 'primary') {
                if (Array.isArray(fieldValues?.[head]) && !fieldValues[head].find(({ name }) => name === value)) {
                    return true;
                }
            } else {
                if (Array.isArray(validFieldName[head]?.options) && !validFieldName[head].options.find(({ name }) => name === value)) {
                    return true;
                }
            }
        }
        return false;
    }

    // Filtered data based on toggles
    const filteredData = useMemo(() => {
        if (!jsonData) return [];
        const applyFilters = (row) => {
            if (showOnlyInvalid && !rowHasIssue(row)) return false;
            if (showOnlyCategoryIssues && !rowHasCategoryIssue(row)) return false;
            return true;
        };
        return jsonData.filter(applyFilters);
    }, [jsonData, showOnlyInvalid, showOnlyCategoryIssues, fileUploadStatus]);

    // Counts for valid/invalid rows
    const { invalidCount, validCount } = useMemo(() => {
        const total = jsonData?.length || 0;
        const inv = (jsonData || []).reduce((n, it) => n + (rowHasIssue(it) ? 1 : 0), 0);
        return { invalidCount: inv, validCount: Math.max(0, total - inv) };
    }, [jsonData, fileUploadStatus]);

    // Reset to first page when filter changes
    useEffect(() => {
        setActivePage(1);
    }, [showOnlyInvalid, showOnlyCategoryIssues]);

    // Compute unique missing categories grouped by parent field
    const missingCategoriesByParent = useMemo(() => {
        if (!Array.isArray(jsonData) || fileUploadStatus > 2) return {};
        const categoryHeads = (validFields || []).filter((vf) => vf !== 'first_name' && vf !== 'last_name' && vf !== 'email');
        const accumulator = {};
        for (let r = 0; r < jsonData.length; r += 1) {
            const row = jsonData[r];
            for (let i = 0; i < categoryHeads.length; i += 1) {
                const head = categoryHeads[i];
                const value = row?.[head];
                if (!value) continue;
                let isValid = true;
                if (validFieldName[head]?.priority === 'primary') {
                    if (Array.isArray(fieldValues?.[head])) {
                        isValid = !!fieldValues[head].find(({ name }) => name === value);
                    }
                } else if (Array.isArray(validFieldName[head]?.options)) {
                    isValid = !!validFieldName[head].options.find(({ name }) => name === value);
                }
                if (!isValid) {
                    const parentKey = validFieldName[head]?.priority === 'primary' ? head : (parentField?.[head] || 'Uncategorized');
                    if (!accumulator[parentKey]) accumulator[parentKey] = {};
                    if (!accumulator[parentKey][head]) accumulator[parentKey][head] = new Set();
                    accumulator[parentKey][head].add(value);
                }
            }
        }
        const result = {};
        Object.keys(accumulator).forEach((parent) => {
            result[parent] = {};
            Object.keys(accumulator[parent]).forEach((field) => {
                result[parent][field] = Array.from(accumulator[parent][field]).sort();
            });
        });
        return result;
    }, [jsonData, validFields, validFieldName, fieldValues, parentField, fileUploadStatus]);

    const totalMissingUnique = useMemo(() => {
        let total = 0;
        Object.values(missingCategoriesByParent || {}).forEach((fieldMap) => {
            Object.values(fieldMap).forEach((arr) => {
                total += Array.isArray(arr) ? arr.length : 0;
            });
        });
        return total;
    }, [missingCategoriesByParent]);

    // Compute paged data slice when filtered data or page changes
    useEffect(() => {
        const length = filteredData?.length || 0;
        const newTotal = Math.max(1, Math.ceil(length / itemsPerPage));
        if (activePage > newTotal) {
            setActivePage(newTotal);
            return; // will re-run on next render with updated activePage
        }
        setTotalPages(newTotal);
        if (length === 0) {
            setPagedData([]);
            return;
        }
        const start = (activePage - 1) * itemsPerPage;
        const end = start + itemsPerPage;
        setPagedData(filteredData.slice(start, end));
    }, [filteredData, activePage]);

    function GetDetails(item, id) {
        // setRowInfo(item)
        setopenPortal(true);
        setRowInfo(item);
        setRowId(id);
        // setRowData(Object.entries(item));
    }

    function DeleteRow(id) {
        // console.log(id)
        setDeleteId(id);
        setConfirmDelete(true);
    }
    function DeleteFileUpload() {
        dispatch({
            type: SG_EDIT_FILE_UPLOAD,
            payload: {
                id: showReportId,
                delete_row: jsonData[deleteId]?.id,
            },
        });
        const _jsonData = jsonData;
        _jsonData.splice(deleteId, 1);
        setJsonData(_jsonData);

        setConfirmDelete(false);
        setDeleteId(null);
    }

    function ImportToDb() {
        setLoadingPage(true)
        const trim = (v) => (typeof v === 'string' ? v.trim() : v);
        const categoryHeads = (validFields || []).filter((vf) => vf !== 'first_name' && vf !== 'last_name' && vf !== 'email');
        const updated = (jsonData || []).map((row) => {
            const next = { ...row };
            next.email = trim(next.email);
            next.first_name = trim(next.first_name);
            next.last_name = trim(next.last_name);
            for (let i = 0; i < categoryHeads.length; i += 1) {
                const head = categoryHeads[i];
                if (Object.prototype.hasOwnProperty.call(next, head)) {
                    next[head] = trim(next[head]);
                }
            }
            return next;
        });
        setJsonData(updated);
        setUploadedEmailList(updated.map((ur) => ur.email));
        dispatch({
            type: SG_EDIT_FILE_UPLOAD,
            payload: {
                id: showReportId,
                import_to_db: 1,
                review_data: updated,
            },
        });
    }
    function ShowPortal(e) {
        setLoadingPage(e)
        setopenPortal(e)
    }

    function RemoveInvalidRows() {
        const remaining = (jsonData || []).filter((it) => !rowHasIssue(it));
        setJsonData(remaining);
        setUploadedEmailList(remaining.map(ur => ur.email));
        setInvalidRows(0);
        setActivePage(1);
    }

    function TrimWhitespaceAndRecheck() {
        const trim = (v) => (typeof v === 'string' ? v.trim() : v);
        const categoryHeads = (validFields || []).filter((vf) => vf !== 'first_name' && vf !== 'last_name' && vf !== 'email');
        const updated = (jsonData || []).map((row) => {
            const next = { ...row };
            next.email = trim(next.email);
            next.first_name = trim(next.first_name);
            next.last_name = trim(next.last_name);
            for (let i = 0; i < categoryHeads.length; i += 1) {
                const head = categoryHeads[i];
                if (Object.prototype.hasOwnProperty.call(next, head)) {
                    next[head] = trim(next[head]);
                }
            }
            return next;
        });
        setJsonData(updated);
        setUploadedEmailList(updated.map((ur) => ur.email));
    }

    return (
        <>
        <DetailsContainer>
            {/* Edit Modal */}
            {openPortal && (
                <ModalOverlay>
                    <Update
                        ShowPortal={ShowPortal}
                        openPortal={openPortal}
                        rowInfo={rowInfo}
                        setRowInfo={setRowInfo}
                        id={showReportId}
                        rowId={rowId}
                        setJsonData={setJsonData}
                        jsonData={jsonData}
                        fieldValues={fieldValues}
                        validFields={validFields}
                        validatedValues={validatedValues}
                        parentField={parentField}
                        controlledBy={controlledBy}
                        validFieldName={validFieldName}
                    />
                </ModalOverlay>
            )}

            {/* Loading Overlay */}
            {loadingPage && (
                <LoadingOverlay>
                    <LoadingSpinner>
                        <LoadingText>Processing upload...</LoadingText>
                    </LoadingSpinner>
                </LoadingOverlay>
            )}

            {/* Header Section */}
            <DetailsHeader>
                <HeaderInfo>
                    {fileUpload?.created_at && (
                        <StatusInfo>
                            <StatusBadge status={fileUploadStatus}>
                                {fileUpload?.status_text}
                            </StatusBadge>
                            <DateInfo>
                                {format(
                                    new Date(fileUpload?.created_at?.toLocaleString()),
                                    "EEEE, MMM do"
                                )}
                            </DateInfo>
                        </StatusInfo>
                    )}
                    {invalidRows > 0 && (
                        <ErrorNotification>
                            <ErrorIcon>⚠</ErrorIcon>
                            <ErrorText>
                                Invalid data found. Please fix the highlighted rows to complete the upload.
                            </ErrorText>
                        </ErrorNotification>
                    )}
                </HeaderInfo>

                <HeaderActions>
                    {fileUploadStatus < 3 && (
                        <ImportButton
                            disabled={invalidRows > 0}
                            onClick={ImportToDb}
                        >
                            <ButtonIcon>⬆</ButtonIcon>
                            Import Data
                        </ImportButton>
                    )}
                    {fileUploadStatus > 2 && (
                        <LogToggleButton onClick={() => setShowUploadLog(!showUploadLog)}>
                            <ButtonIcon>{showUploadLog ? "👁" : "📋"}</ButtonIcon>
                            {showUploadLog ? "Hide" : "Show"} Log
                        </LogToggleButton>
                    )}
                </HeaderActions>
            </DetailsHeader>
            {/* Upload Log Section */}
            {showUploadLog && (
                <LogSection>
                    <LogHeader>
                        <LogTitle>Upload Log</LogTitle>
                        <LogDescription>
                            Detailed information about processed records
                        </LogDescription>
                    </LogHeader>
                    <LogTable>
                        <LogTableHeader>
                            <LogHeaderCell>Row</LogHeaderCell>
                            <LogHeaderCell>Email</LogHeaderCell>
                            <LogHeaderCell>Employee ID</LogHeaderCell>
                            <LogHeaderCell>Status</LogHeaderCell>
                        </LogTableHeader>
                        <LogTableBody>
                            {uploadedLog && uploadedLog?.length > 0 && uploadedLog.map((ll, i) => (
                                <LogTableRow key={i}>
                                    <LogTableCell>{i + 1}</LogTableCell>
                                    <LogTableCell>{ll?.email}</LogTableCell>
                                    <LogTableCell>{ll?.employee_id}</LogTableCell>
                                    <LogTableCell>
                                        <StatusIndicator status={ll?.status}>
                                            {ll?.status}
                                        </StatusIndicator>
                                    </LogTableCell>
                                </LogTableRow>
                            ))}
                        </LogTableBody>
                    </LogTable>
                </LogSection>
            )}

            {/* Main Data Table */}
            <DataSection>
                <DataHeader>
                    <DataTitle>Upload Data Preview</DataTitle>
                    <DataDescription>
                        Review and validate your uploaded data before importing
                    </DataDescription>
                </DataHeader>
                <ControlsBar>
                    <ControlsLeft>
                        <GroupLabel>Filters</GroupLabel>
                        <Checkbox
                            label="Show only rows with issues"
                            checked={showOnlyInvalid}
                            onChange={(e, { checked }) => setShowOnlyInvalid(checked)}
                        />
                        <Checkbox
                            label="Show only rows with category mismatches"
                            checked={showOnlyCategoryIssues}
                            onChange={(e, { checked }) => setShowOnlyCategoryIssues(checked)}
                        />
                    </ControlsLeft>
                    <ControlsRight>
                        <Counts>
                            <CountPill type="valid">Valid: {validCount}</CountPill>
                            <CountPill type="invalid">Invalid: {invalidCount}</CountPill>
                        </Counts>
                        <Button
                            basic
                            size="small"
                            onClick={TrimWhitespaceAndRecheck}
                            disabled={fileUploadStatus > 2}
                        >
                            Trim whitespace & re-check
                        </Button>
                        <Button
                            basic
                            size="small"
                            onClick={() => setShowMissingCategoriesModal(true)}
                            disabled={totalMissingUnique === 0}
                        >
                            View missing categories{totalMissingUnique > 0 ? ` (${totalMissingUnique})` : ''}
                        </Button>
                        <Button
                            basic
                            color='red'
                            size="small"
                            disabled={invalidCount === 0}
                            onClick={RemoveInvalidRows}
                        >
                            Remove invalid rows
                        </Button>
                    </ControlsRight>
                </ControlsBar>
                
                <TableWrapper>
                    <TableScrollContainer>
                        <StyledModernTable>
                            <TableHead>
                                <TableHeaderRow>
                                    {fileHeaders &&
                                        fileHeaders.map((head, i) => {
                                            const Result = validFields.includes(head);
                                            if (head === 'valid') {
                                                return null
                                            }
                                            if (head === 'id') {
                                                return null
                                            }

                                            if (Result) {
                                                return (
                                                    <TableHeaderCell key={i}>
                                                        {head.replace(/_/g, ' ').toUpperCase()}
                                                    </TableHeaderCell>
                                                );
                                            }

                                            return (
                                                <TableHeaderCell key={i} error={true}>
                                                    <CellContent>
                                                        <Popup
                                                            content="Unable to import data in this column"
                                                            trigger={
                                                                <ErrorIconWrapper>
                                                                    <Icon name="attention" />
                                                                </ErrorIconWrapper>
                                                            }
                                                        />
                                                        {head.replace(/_/g, ' ').toUpperCase()}
                                                    </CellContent>
                                                </TableHeaderCell>
                                            );
                                        })}
                                    {fileUploadStatus < 3 && (
                                        <TableHeaderCell style={{ minWidth: '80px' }}>
                                            EDIT
                                        </TableHeaderCell>
                                    )}
                                    {fileUploadStatus < 3 && (
                                        <TableHeaderCell style={{ minWidth: '80px' }}>
                                            DELETE
                                        </TableHeaderCell>
                                    )}
                                </TableHeaderRow>
                            </TableHead>

                            <TableBodyContainer>
                                {pagedData &&
                                    pagedData.map((item, i) => {
                                        const globalIndex = (activePage - 1) * itemsPerPage + i;
                                        const hasError = item.valid === true && fileUploadStatus < 3;
                                        
                                        return (
                                            <DataRow key={globalIndex} hasError={hasError}>
                                                {fileHeaders &&
                                                    fileHeaders.map((head, k) => {
                                                        const Result = validFields.includes(head);
                                                        if (head === 'valid') {
                                                            return null
                                                        }
                                                        if (head === 'id') {
                                                            return null
                                                        }
                                                        
                                                        // file uploaded successfully start
                                                        if (fileUploadStatus > 2) {
                                                            return (
                                                                <DataCell key={k}>
                                                                    {item[head]}
                                                                </DataCell>
                                                            );
                                                        }
                                                        
                                                        // file uploaded successfully end
                                                        if (Result) {
                                                            return <ValidateCheckEmailModern 
                                                                key={k}
                                                                item={item}
                                                                head={head}
                                                                uploadedEmailList={uploadedEmailList}
                                                                uploadStatus={fileUploadStatus}
                                                                fieldValues={fieldValues}
                                                                validEmailList={validEmailList}
                                                                validFieldName={validFieldName}
                                                            />
                                                        }
                                                        
                                                        return (
                                                            <DataCell key={k} error={true}>
                                                                <CellContent>
                                                                    <Popup
                                                                        content="Unable to import this data, not supported field"
                                                                        trigger={
                                                                            <ErrorIconWrapper>
                                                                                <Icon name="attention" />
                                                                            </ErrorIconWrapper>
                                                                        }
                                                                    />
                                                                    {item[head]}
                                                                </CellContent>
                                                            </DataCell>
                                                        );
                                                    })}

                                                {fileUploadStatus < 3 && (
                                                    <DataCell>
                                                        <ActionButton
                                                            onClick={() => GetDetails(item, globalIndex)}
                                                            title="Edit row"
                                                        >
                                                            <Icon name="edit" />
                                                        </ActionButton>
                                                    </DataCell>
                                                )}
                                                {fileUploadStatus < 3 && (
                                                    <DataCell>
                                                        <ActionButton
                                                            onClick={() => DeleteRow(globalIndex)}
                                                            danger={true}
                                                            title="Delete row"
                                                        >
                                                            <Icon name="trash alternate" />
                                                        </ActionButton>
                                                        <Confirm
                                                            open={confirmDelete}
                                                            onCancel={() => setConfirmDelete(false)}
                                                            onConfirm={() => DeleteFileUpload()}
                                                        />
                                                    </DataCell>
                                                )}
                                            </DataRow>
                                        );
                                    })}
                            </TableBodyContainer>
                        </StyledModernTable>
                    </TableScrollContainer>
                </TableWrapper>
                {/* Missing Categories Modal */}
                {showMissingCategoriesModal && (
                    <ModalOverlay>
                        <MissingModal>
                            <MissingHeader>
                                <MissingTitle>Missing categories</MissingTitle>
                                <CloseButton onClick={() => setShowMissingCategoriesModal(false)} title="Close">
                                    <Icon name="close" />
                                </CloseButton>
                            </MissingHeader>
                            <MissingBody>
                                {Object.keys(missingCategoriesByParent || {}).length === 0 && (
                                    <EmptyState>No missing categories found.</EmptyState>
                                )}
                                {Object.entries(missingCategoriesByParent || {}).map(([parentKey, fields]) => (
                                    <MissingGroup key={parentKey}>
                                        <GroupTitle>{String(parentKey).replace(/_/g, ' ')}</GroupTitle>
                                        {Object.entries(fields).map(([fieldKey, values]) => (
                                            <FieldBlock key={fieldKey}>
                                                <FieldTitle>{String(fieldKey).replace(/_/g, ' ')}</FieldTitle>
                                                <TagList>
                                                    {(values || []).map((val) => (
                                                        <Tag key={val}>{String(val)}</Tag>
                                                    ))}
                                                </TagList>
                                            </FieldBlock>
                                        ))}
                                    </MissingGroup>
                                ))}
                            </MissingBody>
                        </MissingModal>
                    </ModalOverlay>
                )}
                    {totalPages > 1 && (
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '12px 0' }}>
                            <Pagination
                                activePage={activePage}
                                totalPages={totalPages}
                                onPageChange={(e, { activePage }) => setActivePage(activePage)}
                                siblingRange={1}
                                boundaryRange={1}
                                size="small"
                            />
                        </div>
                    )}
                </DataSection>
            </DetailsContainer>
        </>
    );
};

export default DebriefScheduleDetail;

// Main Container
const DetailsContainer = styled.div`
    background: white;
    font-family: "Poppins", sans-serif;
    position: relative;
    padding: 24px;
    animation: fadeIn 0.3s ease-out;

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;

// Modal Overlay
const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(4px);
`;

// Missing Categories Modal
const MissingModal = styled.div`
    width: 760px;
    max-width: 92vw;
    max-height: 80vh;
    background: white;
    border-radius: 10px;
    border: 1px solid #e5e7eb;
    box-shadow: 0 10px 30px rgba(0,0,0,0.12);
    display: flex;
    flex-direction: column;
`;

const MissingHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    border-bottom: 1px solid #e5e7eb;
`;

const MissingTitle = styled.div`
    font-weight: 600;
    color: #111827;
`;

const CloseButton = styled.button`
    border: 1px solid #e5e7eb;
    background: white;
    color: #374151;
    border-radius: 8px;
    padding: 6px 8px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: background 0.15s ease;

    &:hover {
        background: #f9fafb;
    }
`;

const MissingBody = styled.div`
    padding: 12px 16px 16px 16px;
    overflow: auto;
`;

const MissingGroup = styled.div`
    padding: 12px 0 8px 0;
    & + & {
        border-top: 1px solid #f3f4f6;
    }
`;

const GroupTitle = styled.div`
    font-size: 13px;
    font-weight: 600;
    color: #111827;
    margin-bottom: 8px;
`;

const FieldBlock = styled.div`
    padding-left: 8px;
    margin-bottom: 10px;
`;

const FieldTitle = styled.div`
    font-size: 12px;
    font-weight: 600;
    color: #374151;
    margin-bottom: 6px;
`;

const TagList = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
`;

const Tag = styled.span`
    font-size: 12px;
    background: #f3f4f6;
    border: 1px solid #e5e7eb;
    color: #374151;
    padding: 2px 8px;
    border-radius: 999px;
`;

const EmptyState = styled.div`
    color: #6b7280;
    font-size: 13px;
`;

// Loading Overlay
const LoadingOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
`;

const LoadingSpinner = styled.div`
    text-align: center;
`;

const LoadingText = styled.div`
    font-size: 16px;
    color: #6b7280;
    margin-top: 16px;
`;

// Header Section
const DetailsHeader = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 24px;
    margin-bottom: 32px;
    padding-bottom: 24px;
    border-bottom: 1px solid #e5e7eb;
`;

const HeaderInfo = styled.div`
    flex: 1;
`;

const StatusInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 12px;
`;

const StatusBadge = styled.div`
    background: ${(props) => {
        if (props.status < 3) return '#fef3c7';
        return '#dcfce7';
    }};
    color: ${(props) => {
        if (props.status < 3) return '#92400e';
        return '#166534';
    }};
    border: 1px solid ${(props) => {
        if (props.status < 3) return '#fcd34d';
        return '#bbf7d0';
    }};
    padding: 4px 12px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.025em;
`;

const DateInfo = styled.div`
    font-size: 14px;
    color: #6b7280;
`;

const ErrorNotification = styled.div`
    background: #fef2f2;
    border: 1px solid #fecaca;
    border-radius: 6px;
    padding: 12px;
    display: flex;
    align-items: flex-start;
    gap: 12px;
`;

const ErrorIcon = styled.div`
    color: #dc2626;
    font-size: 16px;
    line-height: 1;
    margin-top: 1px;
`;

const ErrorText = styled.div`
    font-size: 14px;
    color: #dc2626;
    line-height: 1.4;
`;

const HeaderActions = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

const ImportButton = styled.button`
    background: transparent;
    color: ${(props) => props.disabled ? '#9ca3af' : '#476dfa'};
    border: none;
    border-radius: 6px;
    padding: 12px 20px;
    font-family: "Poppins", sans-serif;
    font-weight: 600;
    font-size: 14px;
    cursor: ${(props) => props.disabled ? 'not-allowed' : 'pointer'};
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 8px;
    opacity: ${(props) => props.disabled ? '0.5' : '1'};

    &:hover:not(:disabled) {
        color: #3d5ce6;
        transform: translateY(-1px);
    }

    &:active:not(:disabled) {
        transform: translateY(0);
    }
`;

const LogToggleButton = styled.button`
    background: transparent;
    color: #6b7280;
    border: none;
    border-radius: 6px;
    padding: 12px 20px;
    font-family: "Poppins", sans-serif;
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 8px;

    &:hover {
        color: #374151;
        transform: translateY(-1px);
    }

    &:active {
        transform: translateY(0);
    }
`;

const ButtonIcon = styled.span`
    font-size: 16px;
    line-height: 1;
`;

// Log Section
const LogSection = styled.div`
    margin-bottom: 32px;
    animation: slideDown 0.3s ease-out;

    @keyframes slideDown {
        from {
            opacity: 0;
            transform: translateY(-10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;

const LogHeader = styled.div`
    margin-bottom: 16px;
`;

const LogTitle = styled.h3`
    font-weight: 600;
    font-size: 18px;
    color: #1f2937;
    margin: 0 0 4px 0;
`;

const LogDescription = styled.p`
    font-size: 14px;
    color: #6b7280;
    margin: 0;
`;

const LogTable = styled.div`
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    overflow: hidden;
`;

const LogTableHeader = styled.div`
    background: #f9fafb;
    display: grid;
    grid-template-columns: 80px 1fr 120px 100px;
    padding: 12px 16px;
    border-bottom: 1px solid #e5e7eb;
`;

const LogHeaderCell = styled.div`
    font-weight: 600;
    font-size: 12px;
    color: #374151;
    text-transform: uppercase;
    letter-spacing: 0.025em;
`;

const LogTableBody = styled.div`
    /* Table body container */
`;

const LogTableRow = styled.div`
    display: grid;
    grid-template-columns: 80px 1fr 120px 100px;
    padding: 12px 16px;
    border-bottom: 1px solid #f3f4f6;
    transition: background-color 0.2s ease;

    &:hover {
        background: #f9fafb;
    }

    &:last-child {
        border-bottom: none;
    }
`;

const LogTableCell = styled.div`
    font-size: 14px;
    color: #374151;
    display: flex;
    align-items: center;
`;

const StatusIndicator = styled.span`
    background: ${(props) => {
        if (props.status === 'success') return '#dcfce7';
        if (props.status === 'error') return '#fef2f2';
        return '#f3f4f6';
    }};
    color: ${(props) => {
        if (props.status === 'success') return '#166534';
        if (props.status === 'error') return '#dc2626';
        return '#374151';
    }};
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
`;

// Data Section
const DataSection = styled.div`
    /* Main data table section */
`;

const DataHeader = styled.div`
    margin-bottom: 20px;
`;

const DataTitle = styled.h3`
    font-weight: 600;
    font-size: 18px;
    color: #1f2937;
    margin: 0 0 4px 0;
`;

const DataDescription = styled.p`
    font-size: 14px;
    color: #6b7280;
    margin: 0;
`;

const ControlsBar = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin: 12px 0 8px 0;
    flex-wrap: wrap;
`;

const ControlsLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
`;

const ControlsRight = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
`;

const GroupLabel = styled.span`
    font-size: 11px;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.04em;
`;

const Counts = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const CountPill = styled.span`
    background: ${(props) => (props.type === 'valid' ? '#dcfce7' : '#fef2f2')};
    color: ${(props) => (props.type === 'valid' ? '#166534' : '#dc2626')};
    border: 1px solid ${(props) => (props.type === 'valid' ? '#bbf7d0' : '#fecaca')};
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
`;

// Modern Table Components
const TableWrapper = styled.div`
    width: 100%;
    margin: 16px 0;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    background: white;
    overflow: hidden;
    max-height: 600px;
    display: flex;
    flex-direction: column;
`;

const TableScrollContainer = styled.div`
    width: 100%;
    overflow-x: auto;
    overflow-y: auto;
    flex: 1;
    
    /* Custom scrollbar styling for horizontal */
    &::-webkit-scrollbar {
        height: 8px;
        width: 8px;
    }
    
    &::-webkit-scrollbar-track {
        background: #f9fafb;
    }
    
    &::-webkit-scrollbar-thumb {
        background: #d1d5db;
        border-radius: 4px;
        
        &:hover {
            background: #9ca3af;
        }
    }
    
    &::-webkit-scrollbar-corner {
        background: #f9fafb;
    }
`;

const StyledModernTable = styled.div`
    min-width: 100%;
    display: table;
    border-collapse: separate;
    border-spacing: 0;
`;

const TableHead = styled.div`
    display: table-header-group;
`;

const TableHeaderRow = styled.div`
    display: table-row;
`;

const TableHeaderCell = styled.div`
    display: table-cell;
    padding: 14px 16px;
    font-family: "Poppins", sans-serif;
    font-weight: 600;
    font-size: 11px;
    color: ${props => props.error ? '#dc2626' : '#374151'};
    text-transform: uppercase;
    letter-spacing: 0.05em;
    border-bottom: 2px solid #e5e7eb;
    white-space: nowrap;
    background: ${props => props.error ? '#fef2f2' : '#f9fafb'};
    min-width: 120px;
    vertical-align: middle;
    position: sticky;
    top: 0;
    z-index: 10;
    box-shadow: 0 1px 0 0 #e5e7eb;
`;

const TableBodyContainer = styled.div`
    display: table-row-group;
`;

const DataRow = styled.div`
    display: table-row;
    background: ${props => props.hasError ? '#fef2f2' : 'white'};
    transition: background-color 0.15s ease;
    
    &:hover {
        background: ${props => props.hasError ? '#fee2e2' : '#f9fafb'};
    }
`;

const DataCell = styled.div`
    display: table-cell;
    padding: 12px 16px;
    font-family: "Poppins", sans-serif;
    font-size: 13px;
    color: #1f2937;
    border-bottom: 1px solid #f3f4f6;
    white-space: nowrap;
    vertical-align: middle;
    background: ${props => {
        if (props.error) return '#fef2f2';
        if (props.valid) return '#f0fdf4';
        return 'transparent';
    }};
    min-width: 120px;
`;

const CellContent = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const CellText = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
`;

const ValidationIcon = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 4px;
    flex-shrink: 0;
    background: ${props => {
        if (props.status === 'success') return '#dcfce7';
        if (props.status === 'error') return '#fee2e2';
        return 'transparent';
    }};
    color: ${props => {
        if (props.status === 'success') return '#16a34a';
        if (props.status === 'error') return '#dc2626';
        return '#6b7280';
    }};
    
    i {
        margin: 0 !important;
        font-size: 12px;
    }
`;

const ErrorIconWrapper = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: #dc2626;
    
    i {
        margin: 0 !important;
        font-size: 14px;
    }
`;

const ActionButton = styled.button`
    background: transparent;
    border: 1px solid ${props => props.danger ? '#fecaca' : '#e5e7eb'};
    border-radius: 6px;
    padding: 6px 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    color: ${props => props.danger ? '#dc2626' : '#6b7280'};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    
    &:hover {
        background: ${props => props.danger ? '#fef2f2' : '#f9fafb'};
        border-color: ${props => props.danger ? '#f87171' : '#d1d5db'};
        transform: translateY(-1px);
    }
    
    &:active {
        transform: translateY(0);
    }
    
    i {
        margin: 0 !important;
        font-size: 14px;
    }
`;

const ModernTable = styled.div`
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    overflow: hidden;
    overflow-x: auto;
`;

const TableBody = styled.div`
    /* Modern table body */
`;

const Headers = styled.div`
    font-family: "Barlow", sans-serif;
    font-weight: bold;
    font-size: 28px;
    margin-top: 40px;
    margin-bottom: 100px;
    padding-bottom: 50px;
`;

const LogHolder = styled.div`
    margin-top: 20px;
    margin-bottom: 100px;
`;
const InfoCentered = styled.div`
    text-align: center;
    font-family: "Barlow", sans-serif;
    font-size: 20px;
    margin-bottom: 25px;
`;

const Org = styled.div`
    font-family: "Barlow", sans-serif;
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 25px;
`;
const Information = styled.div`
    font-family: "Barlow", sans-serif;
    font-size: 20px;
`;

const UploadLogList = styled.div`
    display: flex;
    justify-content:  flex-end 

`

const LogRow = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;

`

const LogCell = styled.div`
    margin: 5px;
    padding: 5px;
`

const StyledTable = styled.div`
    margin-top: 30px;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    padding: 20px;
`;

const TR = styled.div`
    display: flex;
    padding: 15px 10px;
    width: 100%;
`;

const TH = styled.div`
    width: ${(props) => props.width + "%"};
    font-weight: bold;
    border-bottom: 1px solid #9b9b9b;
    padding-bottom: 5px;
`;

const TD = styled.div`
    width: ${(props) => props.width + "%"};
    display: flex;
    align-items: center;
    position: relative;
`;

const T1 = styled.div`
    font-weight: 500;
    font-size: 18px;
`;

const SmallImg = styled.img`
    width: 30px;
    margin-right: 10px;
`;
const RowView = styled.tr`
    cursor: pointer;
`;

const View = styled.div`
    padding: 5px 35px;
    background-color: #6a00ff;
    color: white;
    border-radius: 20px;
    font-weight: bold;
    position: absolute;
    right: 0;
    cursor: pointer;
`;

const Card = styled.div`
    max-width: 100%;
    padding: 30px;
    margin-bottom: 10px;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    //   position:relative;
    display: flex;
    justify-content: space-between;
    //   align-items:center;
`;

const TopContainer = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
`;

const StyledButton = styled.button`
    color: white;
    font-size: 14px;
   
    font-family: "Barlow Semi Condensed", sans-serif;
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: center;
    background-color: ${(props) => (props.disabled ? "#606060" : "#2d50e2")};
    disabled: ${(props) => (props.disabled ? true : false)};
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
    border-radius: 5px;
    border: none;
    outline: none;
    padding: 0px 30px;
    border: 1px solid white;
    margin-right: 5px;

    @media (max-width: 768px) {
        height: 30px;
        font-size: 12px;
        padding: 0 10px 0 10px;
    }

    &:hover {
        background-color: rgba(0, 0, 0, 0);
        border: 1px solid #2d50e2;
        color: #2d50e2;
    }
`;
